import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean;
    busy: boolean;
    onSubmit: () => void;
    onCancel: () => void;
}

export const UserProfileSignatureDelete = ({show, busy, onSubmit, onCancel}:IProps) => (
    <Modal centered className="confirm-dialog" show={show} onHide={onCancel} data-testid="delete-signature-modal">
        <Modal.Header closeButton>
            <Modal.Title>Remove Signature?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="pt-3">Are you sure you want to remove this signature? Doing so will remove this signature for all future visits and the DVM will need to sign each record individually until a new signature is saved.</div>
        </Modal.Body>
        <Modal.Footer className="container-fluid">
            <Button
                aria-label="cancel"
                variant="light"
                className='cancel'
                onClick={onCancel}>Cancel</Button>
            <Button
                aria-label="submit"
                variant="primary"
                className={busy ? 'button-loading' : ''}
                disabled={busy} // disable the submit button if nothing has been drawn.
                onClick={onSubmit}>Remove Signature</Button>
        </Modal.Footer>
    </Modal>
)
